<template>
  <div class="home z-20 relative" v-if="payment">
    <router-view></router-view>
  </div>
</template>

<script>
import store from '@/store'
import { mapState } from 'vuex'
import { checkPaymentErrorAndRedirect } from '@/common/utils'

export default {
  name: 'Home',
  computed: {
    ...mapState('linkToPay', ['payment'])
  },
  watch: {
    'payment.status': {
      deep: true,
      handler: function () {
        this.checkStatus()
      }
    }
  },
  methods: {
    checkStatus () {
      checkPaymentErrorAndRedirect(this.payment)
    }
  },
  async beforeRouteEnter (to, from, next) {
    const currentID = Number(to.params.id)

    if(!isNaN(currentID)) {
      if (store.state.linkToPay.payment && store.state.linkToPay.payment.id === currentID) {
        return next()
      } else {
        await store.dispatch('linkToPay/fetchData', currentID)
        return next(vm => vm.checkStatus())
      }
    }
    return next()
  },
}
</script>